import React, { useMemo } from "react";
import { Button, Grid, CardActions, Divider } from "@material-ui/core";
import ArrowRightIcon from "@material-ui/icons/ArrowRight";
import { Monitor as MonitorIcon } from "react-feather";
import CardStatus from "../../components/CardStatus";
import CardDashboard from "../../components/CardDashboard";
import { useTranslation } from "react-i18next";

const EklokCard = ({ ekloks, updateStatus, action, isPending }) => {
  const { t } = useTranslation();

  const errorCount = useMemo(() => {
    return updateStatus.filter((obj) => (obj.alarm_list ? true : false)).length;
  }, [updateStatus]);

  const connectedCount = useMemo(() => {
    return updateStatus
      ? updateStatus.filter((obj) => obj.connected === true).length
      : 0;
  }, [updateStatus]);

  const notConnectedCount = useMemo(() => {
    return updateStatus
      ? updateStatus.filter((obj) => obj.connected === false).length
      : 0;
  }, [updateStatus]);

  return (
    <CardDashboard
      title={t("ekloks_card.title")}
      value={ekloks ? ekloks.length : "-"}
      avatar={<MonitorIcon />}
      action={
        action ? (
          <>
            <Divider />
            <CardActions>
              <Button
                color="primary"
                fullWidth
                variant="text"
                endIcon={<ArrowRightIcon />}
                onClick={action}
              >
                {t("ekloks_card.action")}
              </Button>
            </CardActions>
          </>
        ) : null
      }
    >
      <Grid container style={{ paddingTop: "1.25rem" }}>
        <Grid item xs={12} md={4}>
          <CardStatus
            type="error"
            title={t("ekloks_card.error")}
            value={isPending ? '...' : errorCount}
          />
        </Grid>
        <Grid item xs={7} md={4}>
          <CardStatus
            type="down"
            title={t("ekloks_card.not_connected")}
            value={isPending ? '...' : notConnectedCount}
          />
        </Grid>
        <Grid item xs={5} md={4}>
          <CardStatus
            type="up"
            title={t("ekloks_card.connected")}
            value={isPending ? '...' : connectedCount}
          />
        </Grid>
      </Grid>
    </CardDashboard>
  );
};

export default EklokCard;
